import styled from 'styled-components';

export const Form = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.25);
    border: solid 0 rgba(255, 255, 255, 0.5);
`;

export const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: calc(100% - 48px);
    padding: 24px;
    gap: 24px;
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 120px;
    height: 120px;
    border-radius: 32px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
`;
export const Image = styled.i`
    font-size: 60px;
    background: linear-gradient(to right, #3ae7ff, #f328f8);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const Paragraph = styled.p`
    white-space: pre-line;
    text-align: center;
`;

export const LabelText = styled.p`
    padding-left: 32px;
    white-space: nowrap;
`;

export const BackButton = styled.button`
    color: var(--link-600);
    background-color: var(--neutral-0);
    border: none;
    transition: 0.2s;
    align-self: center;

    &:hover {
        cursor: pointer;
        color: var(--link-300);
    }
`;

export const LeftIcon = styled.i<{error: number | undefined}>`
    font-size: 20px;
    position: absolute;
    left: 24px;
    //top: 43px;
    color: ${(props) => (props.error ? 'var(--error-500)' : 'var(--neutral-300)')};
    transition: 0.2s;
`;

export const KitContainer = styled.div`
    display: flex;
    justify-content: left;
    flex-direction: column;
    width: calc(100% - 48px);
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
    background-color: var(--neutral-100);
    gap: 12px;
`;

export const KitText = styled.p`
    background: linear-gradient(to right, #3ae7ff, #f328f8 30%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const KitIcon = styled(LeftIcon)`
    color: black;
    left: 48px;
`;

export const KitItem = styled.div`
    text-align: left;
    justify-content: left;
    line-height: 20px;
`;
